import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Task } from '../../types';

interface TaskCompletionButtonProps {
    task: Task;
    collectionId: string;
    onToggleComplete: (taskId: string, collectionId: string) => void;
}

export const TaskCompletionButton: React.FC<TaskCompletionButtonProps> = ({ task, collectionId, onToggleComplete }) => (
    <button
        type="button"
        className={`planner-task-status-button ${task.completed ? 'is-completed' : ''}`}
        onPointerDown={(event) => event.stopPropagation()}
        onClick={(event) => {
            event.stopPropagation();
            onToggleComplete(task.id, collectionId);
        }}
        aria-label={task.title}
        aria-pressed={task.completed}
    >
        {task.completed && <FontAwesomeIcon icon={faCheck} />}
    </button>
);
